module.exports = " <div class=title _v-48cf1988=\"\"> <span _v-48cf1988=\"\">{{ content }}</span> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-48cf1988!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/TitleBar.vue
 ** module id = 345
 ** module chunks = 2
 **/